import { z } from 'zod';

const APPLICANT_EMAIL_KEY = 'myTalquin:apply:applicantEmail';

const applicantEmailSchema = z.email();

/**
 * Retrieves the applicant's email address stored in the session storage.
 * The email is parsed and validated against a predefined schema.
 *
 * @return The validated email address if successful, or null if no valid email is found or an error occurs.
 */
export function getApplicantEmail() {
  try {
    const storageString = sessionStorage.getItem(APPLICANT_EMAIL_KEY);

    if (storageString === null) return null;

    const result = applicantEmailSchema.safeParse(JSON.parse(storageString));

    return result.success ? result.data : null;
  } catch {
    return null;
  }
}

/**
 * Sets the applicant's email address in the session storage.
 *
 * @param applicantEmail - The email address of the applicant to be stored.
 */
export function setApplicantEmail(applicantEmail: string) {
  sessionStorage.setItem(APPLICANT_EMAIL_KEY, JSON.stringify(applicantEmail));
}
